
export class SimpleQueryUser {
    public query?: string;
    public type?: string;
    public descending: boolean;
    public pageNumber: number;
    public pageSize: number;
    public order?: string;
  }